import React from "react";
import SuggestionCard from "../components/SuggestionCard";

const dummyData = [
  { id: 1, name: "Jabal Weibdeh", submittedBy: "user1" },
  { id: 2, name: "Khalda", submittedBy: "user2" },
];

export default function Dashboard() {
  return (
    <div className="p-4">
      <h1 className="text-3xl mb-4">Neighborhood Suggestions</h1>
      {dummyData.map((item) => (
        <SuggestionCard key={item.id} suggestion={item} />
      ))}
    </div>
  );
}
